module.exports = __webpack_public_path__ + "assets/img/header_logo.71f61c99.png";